import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  mobileVerification,
  registerUser,
  sendOtpToMobile,
} from "../../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import { APP_CONST } from "../../../config/const";
import { Toaster } from "../../../utils/toaster";
import { parsePhoneNumber } from "libphonenumber-js";
import PhoneInput from "react-phone-input-2";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import Whatsapp from "../../../assets/images/Whatsapp.svg";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import LoginLeftPartImg from "../../../assets/images/registerbanner.jpg";

import LogoWhite from "../../../assets/images/logo-white.png";

const RegisterModal = ({
  show,
  handleClose,
  handleModalShow,
  agentCode: agentCodeProp,
}) => {
  const { appDetails } = useSelector((state) => state.app);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isOtpRequired = useSelector(
    (state) => state?.app?.appDetails?.OTP === 0
  );
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agentCode, setAgentCode] = useState(agentCodeProp);
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtpValue] = useState("");

  const validateData = (data = null) => {
    const dataToValidate = data ? data : formData;
    const { name, username, password, confirmPassword } = dataToValidate;
    const newErrors = {};
    if (!name || name === "") {
      newErrors.name = "Name cannot be empty";
    }
    if (!username || username === "") {
      newErrors.userName = "User name cannot be empty";
    }
    if (username && (username.length < 4 || username.length > 15)) {
      newErrors.userName = "Username must be 4 to 15 characters.";
    }
    if (!/^[A-Za-z0-9 ]+$/.test(username)) {
      newErrors.userName = "Special characters are not allowed in username.";
    }
    if (!password || password === "") {
      newErrors.password = "Password cannot be empty";
    }
    if (password && (password.length < 8 || password.length > 20)) {
      newErrors.password = "Password must be 8 to 20 characters.";
    }
    if (!confirmPassword || confirmPassword === "") {
      newErrors.confirmPassword = "Confirm password cannot be empty";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Password and Confirm password must be same";
    }
    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errorsData = validateData();

    if (Object.keys(errorsData).length > 0) {
      //setErrors(errorsData);
    } else {
      let dataToSend = { ...formData };
      delete dataToSend.confirmPassword;
      if (agentCode) {
        dataToSend.agent_code = agentCode;
      }
      dispatch(
        registerUser(
          {
            ...dataToSend,
            typeId: 3,
            parentId: 81026,
            mobile: registerConfig.mobileDetails?.mobile,
            country_code: registerConfig.mobileDetails.country_code,
          },
          navigate
        )
      );
      // checkIfExistingUserDetails(formData);
    }
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
    validateData(tempFormData);
  };

  const [registerConfig, setRegisterConfig] = useState({
    isOtpEnabled: useSelector((state) => state?.app?.appDetails) === 0,
    mobileDetails: {},
    isSendingOtp: false,
    isVerifyingOtp: false,
    isOtpSent: false,
    isOtpVerified: false,
    showPassword: false,
    showConfirmPassword: false,
  });

  const handleRegisterConfigChange = (config) => {
    setRegisterConfig((p) => ({ ...p, ...config }));
  };

  const sendOtp = () => {
    const isOtpVerified = !isOtpRequired;
    handleRegisterConfigChange({
      isSendingOtp: true,
      isOtpVerified: isOtpVerified,
    });
    const phoneNumber = parsePhoneNumber("+" + mobileNumber);
    let payload = {};
    payload.mobile = phoneNumber.nationalNumber;
    payload.country_code = phoneNumber.countryCallingCode;

    dispatch(sendOtpToMobile(payload))
      .then((res) => {
        handleRegisterConfigChange({
          mobileDetails: payload,
          isOtpSent: true,
          isSendingOtp: false,
        });
        if (res?.data?.error === false) {
          Toaster(
            APP_CONST.TOAST_TYPE.SUCCESS,
            res?.data?.message || "OTP sent"
          );
        } else {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, res?.data?.message);
        }
      })
      .catch((err) => {
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err?.response?.data?.message);
        handleRegisterConfigChange({
          isSendingOtp: false,
        });
      });
  };

  const verifyOtp = () => {
    handleRegisterConfigChange({
      isVerifying: true,
    });
    dispatch(mobileVerification({ ...registerConfig.mobileDetails, otp }))
      .then((res) => {
        handleRegisterConfigChange({
          isVerifying: false,
          isOtpVerified: true,
        });
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "OTP verified");
      })
      .catch((err) => {
        handleRegisterConfigChange({
          isVerifying: false,
        });
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
      });
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas register-modalL LoginModal RegisterModal"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
    >
      <Modal.Header
        closeButton
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
        closeVariant="white"
      >
        <a href="/">
          {appDetails?.LOGO_URL && (
            // <img src={appDetails?.LOGO_URL} alt="Logo" />
            <img src={LogoWhite} alt="Logo" />
          )}
        </a>
      </Modal.Header>

      <Modal.Body>
        <div>
          <div className="Login-LeftPart">
            <img src={LoginLeftPartImg} alt="LoginLeftPartImg" />
          </div>
        </div>
        <div className="Login-RightPart">
          <div className="Login-rightPart LoginNewDesign">
            <Modal.Title>Sign Up</Modal.Title>
            <p>
              Already a menber?{" "}
              <a
                href="javascript:void(0)"
                onClick={() => {
                  handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                }}
              >
                Login
              </a>
            </p>
          </div>
          <div className="form-steps">
            <Form>
              <Form.Group
                className="mb-4 position-relative registerform"
                controlId="formBasicPassword"
              >
                <label>Name</label>
                <Form.Control
                  type={"text"}
                  name="name"
                  placeholder="Name*"
                  onChange={handleChange}
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors?.name}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                className="mb-4 position-relative registerform"
                controlId="formBasicPassword"
              >
                <label>Username</label>
                <Form.Control
                  type="text"
                  name="username"
                  placeholder="Username*"
                  onChange={handleChange}
                  isInvalid={!!errors.userName}
                  // onBlur={checkUserName}
                />

                <Form.Control.Feedback type="invalid">
                  {errors?.userName}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                className="mb-4 position-relative registerform"
                controlId="formBasicPassword"
              >
                <label>Password</label>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password*"
                  autoComplete="new-password"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  isInvalid={!!errors.password}
                />
                <span
                  className="icon"
                  onClick={() => setShowPassword((p) => !p)}
                >
                  {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                </span>
                <Form.Control.Feedback type="invalid">
                  {errors?.password}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                className="mb-4 position-relative registerform"
                controlId="formBasicPassword"
              >
                <label>Confirm password</label>
                <Form.Control
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirm password*"
                  onChange={handleChange}
                  isInvalid={!!errors.confirmPassword}
                />
                <span
                  className="icon"
                  onClick={() => setShowConfirmPassword((p) => !p)}
                >
                  {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                </span>
                <Form.Control.Feedback type="invalid">
                  {errors?.confirmPassword}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group
                className="mb-4 position-relative registerform"
                controlId="formBasicPassword"
              >
                <label>Agent code</label>
                <Form.Control
                  type={"text"}
                  name="agent_code"
                  className="Agent code"
                  placeholder="Enter Agent/Referral Code"
                  value={agentCode}
                  onChange={(e) => setAgentCode(e.target.value)}
                />
              </Form.Group>

              <div className="get-otp registerform">
                <Form.Group
                  className=" position-relative"
                  controlId="formBasicPassword"
                >
                  <label>Phone number</label>
                  <PhoneInput
                    country={"in"}
                    countryCodeEditable={false}
                    inputProps={{
                      name: "phone",
                      required: true,
                    }}
                    inputStyle={{ width: "100%" }}
                    onChange={(phone) => {
                      setMobileNumber(phone);
                    }}
                  />
                </Form.Group>
              </div>
              <Button
                variant="primary"
                onClick={sendOtp}
                disabled={registerConfig.isSendingOtp}
              >
                {registerConfig.isSendingOtp
                  ? "Loading.."
                  : registerConfig.isOtpSent === true
                  ? "Resend OTP"
                  : "Get OTP"}
              </Button>
              {isOtpRequired ? (
                <div className="verify-otp">
                  <Form.Group
                    className="mb-4 position-relative registerform"
                    controlId="formBasicPassword"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Enter OTP*"
                      onChange={(e) => setOtpValue(e.target.value)}
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    onClick={verifyOtp}
                    disabled={
                      registerConfig.isVerifyingOtp ||
                      !registerConfig.isOtpSent ||
                      !otp
                    }
                  >
                    {!registerConfig.isOtpVerified
                      ? !registerConfig.isVerifyingOtp
                        ? "VERIFY OTP"
                        : "SUBMITTING"
                      : "VERIFIED"}
                  </Button>
                </div>
              ) : null}

              <Button
                variant="primary"
                type="submit"
                className="btn_primary submit-btn"
                onClick={handleSubmit}
                disabled={!registerConfig.isOtpVerified}
              >
                Register
              </Button>
            </Form>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default RegisterModal;
